import { __assign, __extends, __rest } from "tslib";
import { Components, Utils } from '@singularsystems/neo-core';
import React from 'react';
import ComponentBase from './ComponentBase';
/**
 * Renders a div that shows and hides using a vertical collapse animation.
 * Uses the collapsable and collapsed css classes.
 */
var Collapsable = /** @class */ (function (_super) {
    __extends(Collapsable, _super);
    function Collapsable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.containerRef = React.createRef();
        return _this;
    }
    Collapsable.prototype.render = function () {
        var _a = this.props, show = _a.show, hidden = _a.hidden, onHidden = _a.onHidden, domProps = __rest(_a, ["show", "hidden", "onHidden"]);
        domProps.className = Utils.joinWithSpaces(domProps.className, "collapsable");
        return React.createElement("div", __assign({}, domProps, { ref: this.containerRef }), this.props.children);
    };
    Collapsable.prototype.afterRender = function (isInitial) {
        if (this.containerRef.current) {
            if (!this.animationHelper) {
                this.animationHelper = new Components.CollapseAnimationHelper(this.containerRef.current, this.props.show, undefined, this.props.onHidden);
            }
            if (!isInitial) {
                this.animationHelper.showHide(this.props.show, isInitial);
            }
        }
    };
    Collapsable.prototype.componentWillUnmount = function () {
        if (this.animationHelper) {
            this.animationHelper.destroy();
        }
    };
    return Collapsable;
}(ComponentBase));
export default Collapsable;
